import { render, staticRenderFns } from "./fg-header.vue?vue&type=template&id=503b20b9&scoped=true"
import script from "./fg-header.vue?vue&type=script&lang=js"
export * from "./fg-header.vue?vue&type=script&lang=js"
import style0 from "./fg-header.vue?vue&type=style&index=0&id=503b20b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b20b9",
  null
  
)

export default component.exports